import { TrackingEventsState, TrackingEventsActionTypes, TrackingEventsAction } from './types';

const initialState: TrackingEventsState = {
  events: [],
  loading: false,
  error: null,
};

export const trackingEventsReducer = (
  state = initialState,
  action: TrackingEventsAction
): TrackingEventsState => {
  switch (action.type) {
    case TrackingEventsActionTypes.FETCH_TRACKING_EVENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case TrackingEventsActionTypes.FETCH_TRACKING_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        events: action.payload,
      };
    case TrackingEventsActionTypes.FETCH_TRACKING_EVENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}; 